<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Well Schematic Diagram
    </div>
    <div>
        <mat-icon
            mat-dialog-close
            [svgIcon]="'heroicons_solid:x-mark'"
        ></mat-icon>
    </div>
</div>
<hr class="my-0" />

<mat-dialog-content>
    <form [formGroup]="form" class="w-full grid grid-cols-2">
        <mat-form-field class="col-span-4 mt-12">
            <mat-label>Remarks</mat-label>
            <textarea matInput formControlName="remarks"></textarea>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-1" mat-dialog-close>
        Cancel
    </button>
    <button class="btn btn-primary mx-1" (click)="update()">Save</button>
</mat-dialog-actions>
